import CustomPromptTypes from "const/CustomPromptTypes";
import CustomPromptsActions from "actions/CustomPromptsActions";

const {
  FETCH_CUSTOM_PROMPTS_START,
  FETCH_CUSTOM_PROMPTS_DONE,
  FETCH_CUSTOM_PROMPTS_ERROR,
  UPDATE_CUSTOM_PROMPTS_START,
  UPDATE_CUSTOM_PROMPTS_DONE,
  UPDATE_CUSTOM_PROMPTS_ERROR
} = CustomPromptsActions;

const initialState = {
  fetchingData: false,
  data: Object.fromEntries(
    Object.values(CustomPromptTypes).map((type) => [type, type === CustomPromptTypes.ADDITIONAL ? [] : ""])
  )
};

export default (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case FETCH_CUSTOM_PROMPTS_START: {
      return { ...state, fetchingData: true };
    }
    case FETCH_CUSTOM_PROMPTS_DONE: {
      return { ...state, fetchingData: false, data: payload };
    }
    case UPDATE_CUSTOM_PROMPTS_START: {
      return { ...state, fetchingData: true };
    }
    case UPDATE_CUSTOM_PROMPTS_DONE: {
      return { ...state, data: payload, fetchingData: false };
    }
    case FETCH_CUSTOM_PROMPTS_ERROR:
    case UPDATE_CUSTOM_PROMPTS_ERROR: {
      return { ...state, fetchingData: false };
    }
    default: {
      return state;
    }
  }
};
